import { keyByModuleId, orderOfHotKey } from './createKeyMap';
import { MODULE_TYPE } from './config/moduleType';
import { ViewModel, config, PubSub } from '@platform/api'
import { findNextFocusItemInTable } from './util/findNextFocusItemInTable';
import { findPrevFocusItemInTable } from './util/findPrevFoucsItemInTable';
import { findUpStairsFocusItemInTable } from './util/findUpStairsFocusItemInTable';
import { findDownStairsFocusItemInTable } from './util/findDownStairsFocusItemInTable';

const ARROW_KEY = {
    37: handleLeftArrow,
    38: handleUpArrow,
    39: handleRightArrow,
    40: handleDownArrow,
};

/**
 *
 * @param moduleId { String } 事件触发时得到的当前moduleId
 * @param e { Object } 事件源
 * @param key  { String } 触发的按钮
 */

function keyDownOfShiftUp(moduleId, e, key) {
    let nextFocus = key === 'shift+down' ? +1 : -1;

    let nextFocusModuleIdIndex = orderOfHotKey.indexOf(moduleId) + nextFocus;
    let nextFocusModuleId = orderOfHotKey[nextFocusModuleIdIndex];

    if (e.target) { // 逻辑修正
        let code = null;
        // item 根本没有item
        // if (keyByModuleId[moduleId][item]) {
        //     code = keyByModuleId[moduleId][item];
        // }

        if (!isLastModule(nextFocusModuleId) && keyByModuleId[nextFocusModuleId].firstItem) {
            code = keyByModuleId[nextFocusModuleId].firstItem;
        }
        let wrapperDom = document.querySelector(`div[field=${code}]`);
        if (!wrapperDom || !(wrapperDom && wrapperDom.contains(e.target))) {
            e.target.blur();
        }
    }

    if (isLastModule(nextFocusModuleId)) {
        focusInSelfModule({ key, moduleId });
        return;
    }

    //如果下一个聚焦区域没有数据就跳过
    if (nextItemNotHaveData(this.props, moduleId, nextFocusModuleId)) {
        keyDownOfShiftUp.call(this, nextFocusModuleId, e, key);
        return;
    }

    PubSub.publish('autoFocus', {
        data: keyByModuleId[nextFocusModuleId].firstItem,
        moduleId,
    });
}

/**
 * @desc 如果在keyByModuleId中没有找到 nextFocusModuleId 就在当前moduleId中来回跳，从第一个可聚焦点跳到最后一个可聚焦点
 * @param nextFocusModuleId {string}
 * @return {boolean}
 */
function isLastModule(nextFocusModuleId) {
    return keyByModuleId[nextFocusModuleId] === undefined;
}

function focusInSelfModule({ key, moduleId }) {
    let item = key === 'shift+down' ? 'lastItem' : 'firstItem';

    //判断是否有关联tab标签
    if (hasTabRelation(moduleId)) {
        activeItemFocus(moduleId, item);
        return;
    }

    PubSub.publish('autoFocus', {
        data: keyByModuleId[moduleId][item],
        moduleId,
    });
}

// 判断是否有关联表
function hasTabRelation(moduleId) {
    let moduleInfo = keyByModuleId[moduleId];
    return moduleInfo && (moduleInfo.parent || moduleInfo.children);
}

/**
 * @desc: 当前活跃的标签获取焦点
 * @param: moduleId {string} 当前区域Id
 * @param: item {string} 表格里的聚焦项
 */
function activeItemFocus(moduleId, item) {
    //如果当前活跃的标签是undefined 就用区域ID
    let activeKey = ViewModel.tableActiveKey || moduleId;

    PubSub.publish('autoFocus', {
        data: keyByModuleId[activeKey][item],
        moduleId,
    });
}

/**
 * @desc 判断下一个需要聚焦的moduleId是否有数据,如果没有就再次keyDownOfShiftUp,
 * @param props {object}
 * @param currentModuleId {string} 当前聚焦的区域ID
 * @param nextModuleId {string} 下个聚焦的区域ID
 */
function nextItemNotHaveData(props, currentModuleId, nextModuleId) {
    const currentModuleType = keyByModuleId[currentModuleId].type;
    const nextModuleType = keyByModuleId[nextModuleId].type;
    let data = [];

    //type: {form, cardTable, editTable}
    if (currentModuleType === MODULE_TYPE.form) {
        data = getDataByFormDataStructure(props, nextModuleType, nextModuleId);
    } else if (currentModuleType === MODULE_TYPE.cardTable) {
        data = getDataByCardTableDataStructure(props, nextModuleType, nextModuleId);
    } else if (currentModuleType === MODULE_TYPE.editTable) {
        data = getDataByCardTableDataStructure(props, nextModuleType, nextModuleId);
    }

    return data.length === 0;
}
/**
 * 
 * TODO
 * @desc 由于form, table 类型的数据存放于不同的地方
 * @param props
 * @param nextModuleType
 * @param nextModuleId
 */
function getDataByFormDataStructure(props, nextModuleType, nextModuleId) {

    // 可以考虑加个参数控制整个快捷键  TOOD
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }
    let { pageScope } = props.getHotKeyConfig();
    let data;
    if (nextModuleType === MODULE_TYPE.cardTable) {
        let store = pageScope[nextModuleType + 'DataSource'][nextModuleId];
        data = store.getAllRows();
    } else if (nextModuleType === MODULE_TYPE.editTable) {
        let store = pageScope[nextModuleType + 'DataSource'][nextModuleId];
        data = store.getAllRows();
    } else {
        let store = pageScope[nextModuleType + 'DataSource'][nextModuleId];
        data = store.getMetaItems(nextModuleId);
    }

    return data;
}

// TODO
function getDataByCardTableDataStructure(props, nextModuleType, nextModuleId) {
    // 可以考虑加个参数控制整个快捷键  TOOD
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }
    let { pageScope } = props.getHotKeyConfig()

    let data;
    if (nextModuleType === MODULE_TYPE.cardTable) {
        let store = pageScope[nextModuleType + 'DataSource'][nextModuleId];
        data = store.getAllRows();
    } else if (nextModuleType === MODULE_TYPE.editTable) {
        let store = pageScope[nextModuleType + 'DataSource'][nextModuleId];
        data = store.getAllRows();
    } else {
        let store = pageScope[nextModuleType + 'DataSource'][nextModuleId];
        data = store.getMetaItems(nextModuleId);
    }

    return data;
}

/**
 * @desc: 处理上下左右键
 * @param eventTarget {dom} 事件源
 * @param ViewModel {object} 全局变量
 * @param moduleId {string} 区域ID
 * @param orderOfHotKey {array} 区域显示顺序
 * @param itemType {string} 基础组件类型 input/datePicker
 * @param keyCode {number} 按键号
 */
function handleArrowKeyDown({ eventTarget, ViewModel, moduleId, orderOfHotKey, itemType, keyCode }) {
    ARROW_KEY[keyCode]({ eventTarget, ViewModel, moduleId, orderOfHotKey, itemType });
}

/**
 * @desc 处理按左方向键
 * @param eventTarget
 * @param ViewModel
 * @param moduleId
 * @param orderOfHotKey
 * @param itemType
 */
function handleLeftArrow({ eventTarget, ViewModel, moduleId, orderOfHotKey, itemType }) {
    //日期类型延迟执行时eventTarget已被移出document导致寻找不到父元素td,所以日期类型立即执行
    if (itemType === config.hotKeyDatePicker) {
        findPrevFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    //CLOUD-147579 中文输入法下会带进冒号空格等符号，原因是因为输入法的enter比我们的enter后执行导致
    let timer = setTimeout(() => {
        findPrevFocusItemInTable({ eventTarget, ViewModel, moduleId });
        clearTimeout(timer);
    });
}

function handleUpArrow({ eventTarget, ViewModel, moduleId, orderOfHotKey, itemType }) {
    //日期类型延迟执行时eventTarget已被移出document导致寻找不到父元素td,所以日期类型立即执行
    if (itemType === config.hotKeyDatePicker) {
        findUpStairsFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    //CLOUD-147579 中文输入法下会带进冒号空格等符号，原因是因为输入法的enter比我们的enter后执行导致
    let timer = setTimeout(() => {
        findUpStairsFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
        clearTimeout(timer);
    });
}

function handleRightArrow({ eventTarget, ViewModel, moduleId, orderOfHotKey, itemType }) {
    //日期类型延迟执行时eventTarget已被移出document导致寻找不到父元素td,所以日期类型立即执行
    if (itemType === config.hotKeyDatePicker) {
        findNextFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    //CLOUD-147579 中文输入法下会带进冒号空格等符号，原因是因为输入法的enter比我们的enter后执行导致
    let timer = setTimeout(() => {
        findNextFocusItemInTable({ eventTarget, ViewModel, moduleId });
        clearTimeout(timer);
    });
}

function handleDownArrow({ eventTarget, ViewModel, moduleId, orderOfHotKey, itemType }) {
    //日期类型延迟执行时eventTarget已被移出document导致寻找不到父元素td,所以日期类型立即执行
    if (itemType === config.hotKeyDatePicker) {
        findDownStairsFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
        return;
    }

    //CLOUD-147579 中文输入法下会带进冒号空格等符号，原因是因为输入法的enter比我们的enter后执行导致
    let timer = setTimeout(() => {
        findDownStairsFocusItemInTable({ eventTarget, ViewModel, moduleId, orderOfHotKey });
        clearTimeout(timer);
    });
}

export { keyDownOfShiftUp, handleArrowKeyDown };
